var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      on: {
        click: function($event) {
          _vm.closeMenu()
        }
      }
    },
    [
      _c("dd-header", { ref: "menuRef", attrs: { headerType: 2 } }),
      _vm._v(" "),
      _c("main", [
        _c("div", { staticClass: "container" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("section", [
            _c("h2", [_vm._v("mm/style (ミリスタイル)とは？")]),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _c("img", {
              staticClass: "pc_img",
              attrs: {
                src: _vm.getImage("what/desktop_order.png"),
                alt: "商品画面"
              }
            })
          ]),
          _vm._v(" "),
          _vm._m(2),
          _vm._v(" "),
          _c("section", [
            _c("h2", [_vm._v("ご注文の流れ")]),
            _vm._v(" "),
            _c("img", {
              attrs: {
                src: _vm.getImage("what/aboutmmstyle.svg"),
                alt: "ご注文の流れ"
              }
            })
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("h1", [_vm._v("mm/styleとは")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "mm/styleとは、お客様の必要な家具のサイズとスタイルを入力するだけでそのまま注文ができる、デジタルカタログです。"
      ),
      _c("br"),
      _vm._v(
        "\n          「mm/style」の最大の特徴は、お客様自身が1mm単位で寸法を入力し、そのまま注文できることです。出力されるデータは、国内外で特許を取得した独自のシステムにより全て自動生成、工場の機械に直結します。"
      ),
      _c("br"),
      _vm._v(
        "\n          人手や手間を無くすことでオーダー家具でありながら低価格かつ短納期を実現した、家具の常識を覆すカタログです。"
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("h2", [_vm._v("3つのPOINT")]),
      _vm._v(" "),
      _c("ul", { staticClass: "big_text bold" }, [
        _c("li", [
          _vm._v("①現場にあわせて"),
          _c("span", { staticClass: "pickup" }, [
            _vm._v("WHDの3サイズがオーダー")
          ]),
          _vm._v("できる！")
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v("②オーダーなのに"),
          _c("span", { staticClass: "pickup" }, [_vm._v("低価格＆短納期")]),
          _vm._v("!!")
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v("③図面も見積りもその場で確認！"),
          _c("span", { staticClass: "pickup" }, [_vm._v("そのまま注文")]),
          _vm._v("!!")
        ])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "世界唯一のオーダー家具製造システムによって低価格＆短納期でお届けすることが可能です！"
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-47ed1e3f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47ed1e3f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/hakotan/pages/DcWhatMmStyle.vue
// module id = null
// module chunks = 